<section>
  <form class="container-style" [formGroup]="formPriceOrder">
    <div class="row">
      <div class="col-lg-5 col-md-2 col-sm-4 col-6">
        <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranch"
          [required]="true"></app-custom-select>
      </div>
      <div class="col-lg-2 col-md-2 col-sm-2 col-6">
        <app-custom-input-number formControlName="consecutive" [labelText]="'Pedido'"
          [required]="true"></app-custom-input-number>
      </div>
      <div class="col-lg-5 col-md-2 col-sm-4 col-6">
        <app-custom-select formControlName="articleId" [labelText]="'Artículo'" [list]="listArticle"
          [required]="true"></app-custom-select>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-2 col-md-2 col-sm-4 col-6">
        <app-custom-select formControlName="rentalUnitId" [labelText]="'Unidad Alq.'" [list]="listRentalUnit"
          [required]="true"></app-custom-select>
      </div>
      <div class="col-lg-2 col-md-2 col-sm-4 col-6">
        <app-custom-select formControlName="swInvoiceM2" [labelText]="'Unidad Fra.'" [list]="listUnit" [required]="true"
          (onChangeSelect)="changeInvoiceUnit(true)">
        </app-custom-select>
      </div>
      <div class="col-lg-2 col-md-2 col-sm-3 col-6">
        <app-custom-input-decimal formControlName="baseUnitValue" [labelText]="'Precio Lista'">
        </app-custom-input-decimal>
      </div>
      <div class="col-lg-2 col-md-2 col-sm-3 col-6">
        <app-custom-input-decimal formControlName="rateDiscount" [labelText]="'% Dcto.'" [maxFractionDigits]="5"
          (onChangeNumber)="changeRateDiscount()"></app-custom-input-decimal>
      </div>
      <div class="col-lg-2 col-md-2 col-sm-3 col-6">
        <app-custom-input-decimal [value]="discountValue" [labelText]="'Vr.Dcto.'"
          [disabled]="true"></app-custom-input-decimal>
      </div>
      <div class="col-lg-2 col-md-2 col-sm-3 col-6">
        <app-custom-input-decimal formControlName="unitValue" [labelText]="'Vr.Unitario'"
          (onChangeNumber)="changeUnitValue()">
        </app-custom-input-decimal>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <p class="mt-1 text-danger">Definición precios para el pedido (No actualiza Precios por C.Costos)</p>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-end mt-sm-2 mt-md-3">
      <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [disabled]="disable" [variant]="undefined"
        (onClick)="send()">
      </app-custom-button>
    </div>
  </form>
</section>